import { ImgHTMLAttributes } from 'react';
import { ImageWrap } from './ImageWrap';

export function Image({
	className,
	...rest
}: ImgHTMLAttributes<HTMLImageElement>) {
	return (
		<ImageWrap className={className}>
			{/* eslint-disable-next-line jsx-a11y/alt-text */}
			<img {...rest} />
		</ImageWrap>
	);
}
